import styled from "@emotion/styled";
import { useMyTxs } from "../stores/my-txs";
import { useNetworkStore } from "../stores/network";
import { theme } from "../lib/theme";

const Btn = styled.button<{ active: boolean }>`
  background: ${(p) => p.active ? `${theme.colors.primary}22` : "transparent"};
  border: 1px solid ${(p) => p.active ? theme.colors.primary : theme.colors.border};
  border-radius: ${theme.radius.sm};
  color: ${(p) => p.active ? theme.colors.primary : theme.colors.textMuted};
  cursor: pointer;
  padding: 2px 6px;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  transition: all 0.1s;

  &:hover {
    border-color: ${theme.colors.primary};
    color: ${theme.colors.primary};
  }
`;

export function AddToClipboardButton({ hash }: { hash: string }) {
  const { selectedNetwork } = useNetworkStore();
  const { isInClipboard, addToClipboard, removeFromClipboard, getClipboard } = useMyTxs();
  const inClipboard = isInClipboard(selectedNetwork, hash);
  const clipboard = getClipboard(selectedNetwork);

  return (
    <Btn
      active={inClipboard}
      title={inClipboard ? "Remove from comparison" : clipboard.length >= 5 ? "Clipboard full (max 5)" : "Add to comparison"}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (inClipboard) removeFromClipboard(selectedNetwork, hash);
        else addToClipboard(selectedNetwork, hash);
      }}
    >
      {inClipboard ? "✓" : "+"}
    </Btn>
  );
}
